import { Routes, Route } from 'react-router-dom';
import WebPagesList from './list';
import AddWebPage from './add';
import EditWebPage from './edit';
import ViewWebPage from './view';

const WebPages = () => {
  return (
    <Routes>
      <Route path="/" element={<WebPagesList />} />
      <Route path="/add" element={<AddWebPage />} />
      <Route path="/edit/:id" element={<EditWebPage />} />
      <Route path="/view/:id" element={<ViewWebPage />} />
    </Routes>
  );
};

export default WebPages;
